import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import DefaultHeader from '../../container/default-layout/header';
import DefaultSideBar from '../../container/default-layout/side.bar';
import { DefaultFooter } from '../../container/default-layout/footer';
import { Accounts, TableState } from '../../../types/index';
import AppService from "../../../services/app.service";
import Loader from '../../../components/loader';
import AlertDialogSlide from '../../../components/deleteModal';
import { formatDateToDisplay } from "../../../utils/dateUtils";
import Table from "../../../components/Table";

let account = '';
let delink = '';

class Account extends React.Component<
    Accounts,
    TableState
> {

    readonly state: TableState = {
        columns: [
            {
                dataField: "accId",
                text: "ID",
                sort: true,
                classes: "accId content-body",
                headerStyle:{minWidth:50},
                headerClasses: "table_header_color",
                align: "left",
            }, {
                dataField: "accName",
                text: "Name",
                sort: true,
                classes: "name content-body",
                headerStyle: {minWidth: 200},
                headerClasses: "table_header_color",
                align: "left",
            },
            {
                dataField: "accType",
                text: "Type",
                sort: true,
                classes: "accType text-center content-body",
                headerStyle: {minWidth: 100},
                headerClasses: "text-center table_header_color",
                align: "center",
            },
            {
                dataField: "officialEmail",
                text: "Email",
                sort: true,
                classes: "officialEmail content-body",
                headerClasses: "table_header_color",
                align: "left",
            },
            {
                dataField: "accPackage",
                text: "Package",
                sort: true,
                classes: "accPackage text-center content-body",
                headerStyle: {minWidth: 100},
                headerClasses: "text-center table_header_color",
                align: "center",
            },
            {
                dataField: "active",
                text: "Active",
                sort: true,
                classes: "active text-center content-body",
                headerStyle: {minWidth: 100},
                headerClasses: "text-center table_header_color",
                align: "center",
            },
            {
                dataField: "createdDate",
                text: "Created Date",
                sort: true,
                classes: "createdDate text-center content-body",
                headerStyle: {minWidth: 140},
                headerClasses: "text-center table_header_color",
                align: "center",
                formatter: (cell,record) => {
                    return (
                        <Fragment>
                            {record.createdDate == null ? '' : formatDateToDisplay(record.createdDate)}
                        </Fragment>
                    )
                }
            },
            {
                dataField: "action",
                text: "Action",
                classes: "action",
                headerStyle: {width: 200},
                headerClasses: "text-center",
                align: "left",
                formatter: (cell,record) => {
                    return (
                        <Fragment>
                            <Link
                                className="btn btn-primary btn-sm buttons"
                                to={`accounts/edit/${record.accId}`}
                                style={{ marginRight: '5px' }}>
                                <i className="fa fa-edit" title="Edit Account" />
                            </Link>
                            <button
                                className="btn btn-danger btn-sm buttons"
                                onClick={() => this.deleteRecord(record.accId, record.accName)}
                                style={{ marginRight: '5px' }}>
                                <i className="fa fa-trash" title="Delete Account" />
                            </button>
                            {record.active === "Active" && <Link
                                className="btn btn-primary btn-sm buttons"
                                to={`accounts/simulations/${record.accId}`}>
                                <i className="fas fa-link" title="Assign Sims" />
                            </Link>}

                            <button
                                className="btn btn-danger btn-sm buttons"
                                onClick={() => this.delinkSims(record.accId, record.accName)}
                                style={{ marginLeft: '5px' }}>
                                <i className="fa fa-unlink" title="Bulk unlink simulations" />
                            </button>
                        </Fragment>
                    );
                }
            }
        ],
        data: [],
        id: 0,
        isShowingModal: false,
        isShowingDelinkModal: false,
        loading: false,
        totalRecords: 0,
        sort: {
            column: "accName",
            order: "asc"
        }
    };

    handleClick = () => this.setState({ isShowingModal: true });
    handleClose = () => this.setState({ isShowingModal: false });

    handleDelinkClick = () => this.setState({ isShowingDelinkModal: true });
    handleDelinkClose = () => this.setState({ isShowingDelinkModal: false });

    deleteRecord(record, name) {
        this.setState({ id: record });
        account = name;
        this.handleClick();
    }

    delinkSims(accId, name) {
        this.setState({ id: accId });
        delink = name;
        this.handleDelinkClick();
    }

    handleDeleteProcess = async () => {
        this.setState({ loading: true });
        this.handleClose();
        const accounts = await AppService.delete(this.state.id, 'accounts');
        if (accounts.status === 200) {
            this.setState({ data: accounts.data });
        }
        this.setState({ loading: false });
    }

    handleDeLinkProcess = async () => {
        this.setState({ loading: true });
        this.handleDelinkClose();
        const accounts = await AppService.delete(this.state.id, 'accounts/deactivateLinks');
        if (accounts.status === 200) {
            this.setState({ data: accounts.data });
        }
        this.setState({ loading: false });
    }

    loadData = async (queryString: string) => {
        this.setState({ loading: true });
        const accounts = await AppService.getAll(queryString);
        this.setState({ data: accounts.data.accounts });
        this.setState({ totalRecords: accounts.data.totalRecords });
        this.setState({ loading: false });
    }

    componentWillMount = () => {
        this.loadData("accounts?filter_value=&page_number=1&page_size=10&sort_column=accName&sort_order=asc");
    }

    render() {

        return (
            <div>
                <div className="page">
                    <DefaultHeader history={this.props.history} />
                    <div className="page-content d-flex align-items-stretch fields-font">
                        <DefaultSideBar activeAccountLink={true} />
                        <div className="content-inner">
                            {/* <!-- Page Header--> */}
                            <header className="page-header">
                                <div className="container-fluid">
                                    <h2 className="heading">Account Management</h2>
                                </div>
                            </header>
                            {/* <!-- Breadcrumb--> */}
                            <div className="breadcrumb-holder container-fluid">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item breadcrumb-list"><Link to='/dashboard'>Dashboard</Link></li>
                                    <li className="breadcrumb-item active breadcrumb-list">Account Management</li>
                                </ul>
                            </div>
                            <section className="tables">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="card">
                                                <div className="card-close">
                                                    <div className="dropdown">
                                                        <Link className="dropdown-toggle" to='/accounts/add'><i className="fas fa-plus" title='Add Account' /></Link>
                                                    </div>
                                                </div>
                                                <div className="card-header d-flex align-items-center">
                                                    <h3 className="sub-heading">Accounts</h3>
                                                </div>

                                                <div className="card-body">
                                                    <div className="table-responsive data-table-wrapper table-heading">
                                                        <Table
                                                            data={this.state.data}
                                                            columns={this.state.columns}
                                                            total={this.state.totalRecords}
                                                            apiUrl="accounts"
                                                            getData={this.loadData}
                                                            defaultSort={this.state.sort.column}
                                                            defaultOrder={this.state.sort.order}
                                                            id="accId"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <DefaultFooter />
                            {(this.state.loading) && <div className="overlay">
                                <Loader loading={this.state.loading} />
                            </div>}
                        </div>
                    </div>
                </div>
                <AlertDialogSlide
                    show={this.state.isShowingModal}
                    handleNo={this.handleClose}
                    handleYes={this.handleDeleteProcess}
                    title="Delete Account"
                >
                    <p className="fields-font">Are you sure you want to delete the account <span className="span">{account}</span> ? This action will revoke all access codes generated for this account.</p>
                </AlertDialogSlide>

                <AlertDialogSlide
                    show={this.state.isShowingDelinkModal}
                    handleNo={this.handleDelinkClose}
                    handleYes={this.handleDeLinkProcess}
                    title="Bulk Unlink Simulations"
                    positiveButtonTitle="Delink"
                >
                    <p className="fields-font">Are you sure you want to delink all the simulations associated with the account <span className="span">{delink}</span> ?</p>
                </AlertDialogSlide>
            </div>

        );
    }

}

export default Account;